var _path, _path2, _path3, _g, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37835e-06 90V295C-0.00131202 299.766 0.936016 304.485 2.75855 308.888C4.58108 313.292 7.25316 317.293 10.6221 320.664C13.991 324.035 17.9908 326.709 22.3932 328.534C26.7956 330.359 31.5144 331.299 36.28 331.3H228.8C238.427 331.3 247.66 327.476 254.468 320.668C261.276 313.86 265.1 304.627 265.1 295V36.3C265.1 26.6726 261.276 17.4396 254.468 10.632C247.66 3.82446 238.427 0 228.8 0H90L18.83 71.15L1.37835e-06 90Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90L18.85 71.15L90 0H228.78C238.407 0 247.64 3.82446 254.448 10.632C261.256 17.4396 265.08 26.6726 265.08 36.3V120.71H0V90Z",
    fill: "#6972B1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9902L44.4301 99.8102C53.8594 101.751 63.6735 99.8689 71.7158 94.5773C79.7581 89.2858 85.3706 81.0178 87.3199 71.5902L89.1801 61.4102C88.5907 64.2176 87.6569 66.9415 86.4 69.5202C83.4275 75.6568 78.7862 80.8319 73.0081 84.4523C67.2299 88.0727 60.5487 89.992 53.73 89.9902H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99H53.73C60.5487 89.9918 67.2299 88.0726 73.0081 84.4522C78.7862 80.8318 83.4275 75.6567 86.4 69.52C88.7641 64.5844 89.9941 59.1825 90 53.71V0L18.8199 71.16L0 89.99Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.571 282.95C100.211 282.95 73.8906 256.01 73.8906 222.89C73.8906 189.77 100.211 162.84 132.571 162.84C164.931 162.84 191.261 189.78 191.261 222.89C191.261 256 164.931 282.95 132.571 282.95ZM132.571 173.95C106.361 173.95 85.0206 195.89 85.0206 222.86C85.0206 249.83 106.361 271.78 132.571 271.78C158.781 271.78 180.121 249.84 180.121 222.86C180.121 195.88 158.791 173.98 132.571 173.98V173.95Z",
    fill: "#6972B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.517 216.84L125.727 200.39C124.662 199.748 123.444 199.402 122.2 199.388C120.956 199.373 119.73 199.69 118.65 200.306C117.569 200.923 116.672 201.816 116.051 202.894C115.43 203.972 115.108 205.196 115.117 206.44V239.35C115.108 240.594 115.43 241.818 116.051 242.896C116.672 243.974 117.569 244.867 118.65 245.484C119.73 246.1 120.956 246.417 122.2 246.402C123.444 246.388 124.662 246.042 125.727 245.4L153.517 228.94C154.576 228.324 155.454 227.441 156.065 226.379C156.675 225.318 156.996 224.115 156.996 222.89C156.996 221.665 156.675 220.462 156.065 219.401C155.454 218.339 154.576 217.456 153.517 216.84Z",
    fill: "#6972B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.3098efed8128edd23f344ab392b9ec89.svg";
export { ForwardRef as ReactComponent };